import { areStringsEquivalent, isQuoted, normalize } from './strings';
export var filterJqlValue = function filterJqlValue(_ref, query) {
  var displayName = _ref.displayName,
    value = _ref.value;
  if (typeof query !== 'string' || query === '') {
    return true;
  }
  var normalizedQuery = normalize(query);
  var normalizedDisplayName = normalize(displayName);
  var normalizedValue = normalize(value);

  // If query is quoted, then we only return exact matches with the JQL value
  if (isQuoted(query)) {
    return areStringsEquivalent(normalizedQuery, normalizedValue);
  }
  return areStringsEquivalent(normalizedQuery, normalizedDisplayName.substring(0, normalizedQuery.length)) || areStringsEquivalent(normalizedQuery, normalizedValue.substring(0, normalizedQuery.length));
};